import "../../utils/tailwind.css";
import { PageProvider, useCaseStudiesProvider } from "./provider";

import Label from "../../components/label";
import Section from "../../components/section";
import Input from "../../components/input";
import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";
import ImageUploader from "../../components/upload-image";

export default function CaseStudiesPage() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    getCaseStudiesQuery,
    handleEditClick,
    handleDeleteClick,
    handleAddClick,
    handleOnChange,
  } = useCaseStudiesProvider();

  return (
    <Section>
      <div className="flex items-center justify-between gap-4 mb-4">
        <div>
          <h2 className="text-xl font-bold text-black">Case Studies</h2>
          <p className="text-sm text-gray-500">Manage all dynamic case study pages and content.</p>
        </div>
        <button
          type="button"
          className="bg-black text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-gray-800 transition"
          onClick={handleAddClick}>
          <Plus className="text-white w-4 h-4" />
          <span>Add Case Study</span>
        </button>
      </div>

      <div className="flex items-center justify-between gap-4 mb-4">
        <Input
          onChange={handleOnChange}
          placeholder="Search by heading, client, category or keywords..."
          className="flex-1"
        />
      </div>

      <div className="overflow-x-auto mb-10">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                Title & Slug
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                Client / Category
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                Date
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[120px]">
                Banner
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 text-center w-[90px]">
                Status
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 text-center w-[90px]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {getCaseStudiesQuery?.isLoading ? (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">
                  Loading case studies...
                </td>
              </tr>
            ) : getCaseStudiesQuery?.data?.data?.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">
                  No case studies found. Click "Add Case Study" to create one.
                </td>
              </tr>
            ) : (
              getCaseStudiesQuery?.data?.data?.map((item, index) => (
                <tr key={item._id || index} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-3 py-3">
                    <Label
                      className="font-medium text-black text-[15px] mb-1"
                      label={item.title}
                    />
                    <span className="text-xs text-blue-600 font-mono block">
                      /case-studies/{item.slug_url}
                    </span>
                  </td>
                  <td className="border border-gray-300 px-3 py-3">
                    <div className="text-sm font-semibold text-gray-800">{item.client || "-"}</div>
                    <div className="text-xs text-gray-500">{item.category || "-"}</div>
                  </td>
                  <td className="border border-gray-300 px-3 py-3 text-sm text-gray-700">
                    {item.date || "-"}
                  </td>
                  <td className="border border-gray-300 px-3 py-3 text-center">
                    {item.banner_img ? (
                      <ImageUploader
                        imgStyle={{ width: "5rem", height: "3rem", objectFit: "cover" }}
                        imageUrl={item.banner_img}
                      />
                    ) : (
                      <span className="text-xs text-gray-400">No Image</span>
                    )}
                  </td>
                  <td className="border border-gray-300 px-3 py-3 text-center">
                    <span
                      className={`inline-block px-2 py-1 text-xs rounded-full font-semibold ${
                        item.is_publish
                          ? "bg-green-100 text-green-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}>
                      {item.is_publish ? "Published" : "Draft"}
                    </span>
                  </td>
                  <td className="border border-gray-300 px-3 py-3 text-center">
                    <div className="flex items-center justify-center space-x-3">
                      <Pencil
                        className="cursor-pointer text-gray-700 hover:text-black"
                        onClick={() => handleEditClick(item)}
                      />
                      <Trash
                        className="cursor-pointer text-red-600 hover:text-red-800"
                        onClick={() => handleDeleteClick(item)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </Section>
  );
}
